// extracted by mini-css-extract-plugin
export var cutOff = "PhoneFramedContent-module--cutOff--ZFsnZ";
export var full = "PhoneFramedContent-module--full---Q5BE";
export var image = "PhoneFramedContent-module--image--oz1iM";
export var innerContainer = "PhoneFramedContent-module--innerContainer--n9ADH";
export var outerFrame = "PhoneFramedContent-module--outerFrame--x2eJc";
export var phoneContainer = "PhoneFramedContent-module--phoneContainer--YlGDe";
export var video = "PhoneFramedContent-module--video--UhmkJ";